module.exports = __webpack_public_path__ + "fonts/bold.d459f34b.woff";